















import { Component, Vue } from 'vue-property-decorator';

import { Store } from '@/enums/Store';

import { Location } from '@/util/Location';

import { namespace } from 'vuex-class';

const LOCATION = namespace(Store.LOCATION);
const App = namespace(Store.APP);

@Component({})
export default class LocationOverview extends Vue {
  @LOCATION.State('location') location?: Location;
  @LOCATION.State('locationCode') locationCode?: string;
  @App.State('promoterId') promoterId!: number;
}
